// extracted by mini-css-extract-plugin
module.exports = {"logoLight":"logo_logoLight__p4C8_","logoDark":"logo_logoDark__CyMk_","logoText":"logo_logoText__bb7Xw"};